import BaseModel from "../api/models/BaseModel";

/**
 * CertificateStatus
 */
export default class CertificateStatus extends BaseModel{
    
    constructor() {
        super();

        this.PENDING = 1,
        this.VALID = 2,
        this.INVALID = 3
    }

}